import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { APPS_CONFIG } from "../../config/appsConfig";
import AppCard from "../UI/AppCard";
import "./MainDashboard.css";
import { FiLogOut } from "react-icons/fi";
// Import theme for JavaScript usage (colors are already applied via CSS)
// import theme from "../../config/theme";

const MainDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleAppClick = (appKey) => {
    const config = APPS_CONFIG[appKey];
    if (config) {
      navigate(config.route);
    }
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="main-dashboard">
      <div className="dashboard-header">
        <button onClick={handleLogout} className="logout-btn">
          Logout <FiLogOut />
        </button>

        <div className="header-content">
          <h1>Welcome, {user?.firstName}!</h1>
          <p className="dashboard-subtitle">
            Select an application to continue
          </p>
        </div>
      </div>

      <div className="apps-grid">
        {user?.userPermissions?.map((permission, index) => {
          const config = APPS_CONFIG[permission.app];
          if (!config) return null;

          return (
            // <AppCard
            //   key={`${permission.app}_${permission._id}_${index}`}
            //   title={config.title}
            //   color={config.color}
            //   permissions={permission.navs}
            //   onClick={() => handleAppClick(permission.app)}
            // />

            <AppCard
              key={`${permission.app}_${permission._id}_${index}`}
              appKey={permission.app}
              title={config.title}
              color={config.color}
              contrastColor={config.contrastColor}
              darkerColor={config.darkerColor}
              gradient={config.gradient} // NEW: Use the pre-defined gradient
              permissions={permission.navs}
              onClick={() => handleAppClick(permission.app)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MainDashboard;
